import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import { Col, Modal, Row, Spinner, UncontrolledTooltip } from "reactstrap"
import { getTemplates, removeTemplate } from "services/exports/calls"
import { getCheckboxes } from "services/orders/tracking/calls"
import { getRoles } from "services/users/calls"

const { SearchBar } = Search

const ListTemplates = props => {
  const { reRender, t } = props
  const [limit] = useState(10)
  let history = useHistory()
  const [showConfirm, setShowConfirm] = useState(false)
  const [confirm, setConfirm] = useState({})
  const [templatesList, setTemplatesList] = useState([])
  const [hasError, setError] = useState(false)
  const [checkboxes, setCheckboxes] = useState([])
  const [listaPerfis, setListaPerfis] = useState()

  const [modalDetails, setModalDetails] = useState(false)
  const [fields, setFields] = useState({})

  const [isLoading, handleLoading] = useState(true)

  const initPageOptions = {
    sizePerPage: limit,
    totalSize: 0,
    custom: true,
    showTotal: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    prePageText: t("Anterior"),
    nextPageText: t("Próximo"),
    paginationTotalRenderer: (from, to, size) => {
      return (
        <div className="d-inline">
          <span className="react-bootstrap-table-pagination-total">
            {t("Registros Retornados")}: {size}
          </span>
        </div>
      )
    },
  }

  const [pageOptions, setPageOptions] = useState(initPageOptions)

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: true,
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "templateName",
      text: t("Nome"),
      sort: false,
      formatter: (cellContent, row) => cellContent || 0,
    },
    {
      dataField: "roles",
      isDummyField: true,
      text: t("Perfil"),
      sort: false,
      formatter: (cellContent, row) => {
        const rolesIds = row.roleId?.split(",")
        const roles = rolesIds?.map(ri => {
          const role = listaPerfis.find(lp => lp.id === Number(ri))
          if (role) {
            return role.name
          }
        })
        return roles?.join(", ")
      },
    },
    {
      dataField: "fields",
      isDummyField: true,
      text: t("Campos"),
      headerAlign: "center",
      align: "center",
      headerStyle: () => {
        return { width: "10%" }
      },
      formatter: (cellContent, row) => {
        return (
          <ul className="list-unstyled mb-0">
            <li>
              <Link
                to="#"
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  setModalDetails(true)
                  const campos = JSON.parse(row.filters)?.filters
                  const mapedFields = campos?.map(e => {
                    return checkboxes.filter(c => c.column === e)[0]?.title
                  })
                  setFields(mapedFields.join(", "))
                }}
              >
                <i
                  className="mdi mdi-eye-outline"
                  id={`fieldsTooltip${row.id}`}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`fieldsTooltip${row.id}`}
                >
                  {t("Visualizar")}
                </UncontrolledTooltip>
              </Link>
            </li>
          </ul>
        )
      },
    },
    {
      dataField: "options",
      isDummyField: true,
      text: t("Opções"),
      headerAlign: "center",
      align: "center",
      headerStyle: () => {
        return { width: "10%" }
      },
      formatter: (cellContent, row) => {
        if (!row.deletedAt) {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    history.push(`/rastreio/exportacao/templates/${row.id}`)
                    props.setNav(3)
                  }}
                >
                  <i
                    className="mdi mdi-pencil-outline"
                    id={`edittooltip${row.id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`edittooltip${row.id}`}
                  >
                    {t("Editar")}
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    setConfirm({
                      title: "Confirmação",
                      body: (
                        <div>
                          <p>{t("Essa ação é irreversivel!")}</p>
                          <p>
                            {t("Apagar1")}
                            {t("Apagar2")}
                          </p>
                        </div>
                      ),
                      onConfirm: () => {
                        onDeleteTemplate(row.id)
                      },
                    })
                    setShowConfirm(true)
                  }}
                >
                  <i
                    className="mdi mdi-delete-forever"
                    id={`deletetooltip${row.id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip${row.id}`}
                  >
                    {t("Excluir")}
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          )
        }
      },
    },
  ]

  const sortByColumnName = (a, b) => {
    var textA = a.title.toUpperCase()
    var textB = b.title.toUpperCase()
    return textA < textB ? -1 : textA > textB ? 1 : 0
  }

  const fetchCheckBoxes = async () => {
    const { checkboxes } = await getCheckboxes()
    const uniqueCheckboxes = Array.from(
      new Set(checkboxes.map(a => a.column))
    ).map(column => {
      return checkboxes.find(a => a.column === column)
    })
    setCheckboxes(
      uniqueCheckboxes.sort(sortByColumnName).map((c, i) => ({
        ...c,
        checked: true,
      }))
    )
  }

  const fetchTemplates = async () => {
    try {
      setError(false)
      const { payload: roles } = await getRoles()
      setListaPerfis(roles?.roles)
      const { payload: templates } = await getTemplates()
      setTemplatesList(templates)
    } catch (err) {
      setError(err)
      console.error(err)
    } finally {
      handleLoading(false)
    }
  }

  useEffect(() => {
    handleLoading(true)
    fetchCheckBoxes()
    fetchTemplates()
  }, [reRender])

  const onDeleteTemplate = async id => {
    try {
      await removeTemplate(id)
      fetchTemplates()
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      {!isLoading && (
        <div>
          {templatesList?.length > 0 && (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={templatesList}
            >
              {({ paginationTableProps, paginationProps }) => (
                <ToolkitProvider
                  keyField="id"
                  columns={columns}
                  columnToggle
                  data={templatesList}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row>
                        <SearchBar
                          {...toolkitProps.searchProps}
                          placeholder="Pesquisar"
                        />
                        <hr />
                      </Row>

                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField={"id"}
                              responsive
                              bordered={true}
                              striped={true}
                              defaultSorted={defaultSorted}
                              selectRow={selectRow}
                              classes={"table align-middle table-nowrap"}
                              headerWrapperClasses={"thead-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                            />
                          </div>
                        </Col>
                      </Row>
                      <PaginationListStandalone {...paginationProps} />
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
          {templatesList.length === 0 && (
            <div style={{ textAlign: "center" }}>
              <h5>{t("Nenhum dado encontrado.")}</h5>
            </div>
          )}
        </div>
      )}
      {isLoading && (
        <div className="mt-3" style={{ textAlign: "center" }}>
          <Spinner className="ms-2" color="primary" />
        </div>
      )}
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
        onClosed={() => {
          fetchTemplates()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {props.t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              confirm?.onConfirm()
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalDetails}
        toggle={() => {
          setModalDetails(!modalDetails)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Campos selecionados</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalDetails(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{fields}</div>
      </Modal>
    </>
  )
}

ListTemplates.propTypes = {
  t: PropTypes.any,
  reRender: PropTypes.bool,
  setUserId: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(ListTemplates)
